import { InlineNotification } from '@packages/shared';
import { useIntl } from 'react-intl';
import { ErrorFallbackMessages } from './messages';

export type SampleOrderErrorFallbackProps = {
  onCloseHandler?(): void;
};

export const SampleOrderErrorFallback = ({ onCloseHandler }: SampleOrderErrorFallbackProps) => {
  const { formatMessage } = useIntl();
  return (
    <InlineNotification onClose={onCloseHandler} severity="warning">
      {formatMessage(ErrorFallbackMessages.RequestError)}
    </InlineNotification>
  );
};
